import React from 'react';
import { useState  } from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { useNavigate  } from "react-router-dom";

const Config = () => {
    const navigate = useNavigate();

    const [confGenerated,setConfGenerated] = useState("");
    const [domain,setDomain] = useState("");

    const [tenant, setTenant] = useState("");
    const onInputTenant = ({target:{value}}) => setTenant(value);

    const [background, setBackground] = useState("");
    const onInputBackground = ({target:{value}}) => setBackground(value);

    const [language, setLanguage] = useState("it-IT");
    const onInputLanguage = ({target:{value}}) => setLanguage(value);

    const demo = () => {
        
        navigate("/?cfg=eyJiYWNrZ3JvdW5kIjoidXJsKGh0dHBzOi8vbWV0YWh1bWFuLmludGVybG9naWNhLmFpL3N0YXRpYy9tZWRpYS9pbnRlcmxvZ2ljYS5qcGcpIiwibGFuZ3VhZ2UiOiJpdC1JVCIsInRlbmFudCI6IjQ0YTJjOGRjLTEyMTItNGFiOS04NGM0LWM5NWZiN2M2YTkxZSJ9");
    }

    const generate = (e)  => {
        e.preventDefault();
            let full = window.location.protocol + '//' + window.location.hostname + ':' +  window.location.port + "?cfg=";
            
            let jsObject = {
                "background" : "url(" + background + ")",
                "language": language,
                "tenant" : tenant,
                "inputbox": true,
                "notifier" : true,   
            }


            let encodedObject = window.btoa(JSON.stringify(jsObject));

            setConfGenerated(encodedObject);
            setDomain(full);
    }

    return (
        <div>

            <Card className="center-card" style={{ width: '28rem' }}>
                <Card.Img style={{ padding: '15px' }} variant="top" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
                <Card.Body>
                    <Card.Title>Make Config</Card.Title>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicTenat">
                            <Form.Label>Tenant</Form.Label>
                            <Form.Control type="text" placeholder="Enter tenant id" onChange={onInputTenant} value={tenant} />
                            <Form.Text className="text-muted">
                                format like this : 44a2c8dc-1212-4ab9-84c4-c95fb7c6a91e
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicBackground">
                            <Form.Label>Background Image Url</Form.Label>
                            <Form.Control type="text" placeholder="" onChange={onInputBackground} value={background} />
                            <Form.Text className="text-muted">
                                format like this : https://metahuman.interlogica.ai/static/media/interlogica.jpg
                            </Form.Text>     
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicLanguage">
                            <Form.Label>Speech Recognition Language</Form.Label>
                            <Form.Control type="text" placeholder="it-IT" onChange={onInputLanguage} value={language} /> 
                        </Form.Group>
                        <Button variant="primary" type="submit" onClick={generate} >
                            Generate
                        </Button>
                        &nbsp;&nbsp;
                        <Button variant="secondary" type="submit" onClick={demo} >
                            Demo
                        </Button>
                    </Form>

                </Card.Body>
            </Card>
            <Card className="center-card" style={{ width: '28rem' }}>
            <Card.Body>
            <Card.Title>Configuration</Card.Title>
            <a href={'/?cfg=' + confGenerated}>{domain}{confGenerated}</a>
            </Card.Body>  
            </Card>



        </div>
    );
};

export default Config;